import { Box, Typography } from "@mui/material"
import React from "react"

// site chrome, screen only — a copyright line belongs to the site, not the
// résumé PDF the sheet footer builds
const FIRST_YEAR = 2021
const year = new Date().getFullYear()
const range = year > FIRST_YEAR ? `${FIRST_YEAR}–${year}` : `${FIRST_YEAR}`

export const SiteFooter: React.FC = () => {
    return (
        <Box
            className="no-print"
            component="footer"
            sx={{
                // no border-top (the sheet above draws its own edge); centered
                // on the sheet's axis
                px: 3,
                pt: 3,
                pb: 5,
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Typography
                sx={{
                    fontFamily: '"DM Mono", monospace',
                    // 13px floor for tertiary chrome — 12px mono read too
                    // small on phones
                    fontSize: 13,
                    // text.secondary, not faint: zinc-500 fails contrast on
                    // the page background
                    color: "text.secondary",
                    // wraps as one unit — inline when it fits, whole-line drop
                    // when it doesn't
                    "& .motto": { whiteSpace: "nowrap" },
                    // © glyph sized to match the year's digits, sunk back onto
                    // the line
                    "& .copyright-mark": { fontSize: "1.5em", verticalAlign: "-0.12em" },
                }}
            >
                <span className="copyright-mark">©</span> {range} Wisaroot Lertthaweedech{" "}
                <span className="motto">· idempotent by design: safe to refresh</span>
            </Typography>
        </Box>
    )
}
